import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_247: DocMigration = {
  maxSchemaVersion: "0.0.247",
  description: "Remove View state",
  apply(json: any) {
    delete json.activeViewId;
    delete json.openViewIds;

    return json;
  },
};

export default migration_0_0_247;
